import { Database, Model } from '@nozbe/watermelondb';

const addRelatedDataBatch = async (data: Model[], database: Database) => {
    await database.batch(...data);
};

export { addRelatedDataBatch };
